/*
 *   Copyright (c) 2023 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 *   See License in the LICENSE file
 */
/*!
 * FIT Project v1.0.0 (https://www.list.lu/)
 * Copyright 2017-2022 Emmanuel DENOYELLE
 * Licensed under the GPL-2.0-or-later license
 */
let _paq: any;

export const orejimeConfig = {
  elementID: "orejime",
  appElement: "#app",
  cookieName: "cookieconsent_status",
  cookieExpiresAfterDays: 1,
  cookieDomain: "*.fairnessinteaching-project.eu",

  stringifyCookie: (contents: any) => JSON.stringify(contents),
  parseCookie: (cookie: any) => JSON.parse(cookie),

  privacyPolicy: "https://www.fairnessinteaching-project.eu/cookie-policy",
  default: false,
  mustConsent: false,
  mustNotice: false,
  lang: "en",
  logo: false,
  debug: false,

  translations: {
    en: {
      poweredBy: false,
      consentNotice: {
        description:
          "This website uses cookies to obtain anonymous visitor statistics to optimize its ergonomics, navigation and content.",
      },
      consentModal: {
        title: "Cookies management",
        description:
          "This website uses cookies. Cookies are small text files that are sent and stored to your personal computer or device when you visit a website. The information stored may be returned to the website’s servers or to the servers of the relevant third parties during a subsequent visit.\n " +
          "Cookies have different functions. In general, cookies are necessary for the website to work in a correct way (for instance, by saving your current session). Cookies can also be used to analyse your browsing behaviour and to optimize your experience.",
        privacyPolicy: {
          name: "cookie policy",
        },
      },
      purposes: {
        analytics:
          "Theses cookies are used to obtain anonymous site traffic statistics in order to optimize its ergonomics, navigation and content. By disabling these cookies, we will not be able to analyze traffic on the website.",
        internal:
          "These cookies are used to enable you to visit the website and its features and they are automatically deleted once the navigation browser is closed.",
      },
      app: {
        optOut: { title: "" },
        required: { title: "" },
        purpose: "Purpose",
      },
    },
  },

  apps: [
    {
      name: "internal-tracker",
      title: "Technical cookies",
      purposes: ["internal"],
      required: true,
    },
    {
      name: "matomo",
      title: "Matomo",
      cookies: [
        [/^_pk_.*$/, "/", "*.fairnessinteaching-project.eu"],
        [/^_mtm_.*$/, "/", "*.fairnessinteaching-project.eu"],
        [/^MATOMO.*$/, "/", "*.fairnessinteaching-project.eu"],
      ],
      purposes: ["analytics"],

      callback: function (consent: any, app: any) {
        if (!!_paq) {
          if (consent == true) {
            _paq.push(["setCookieConsentGiven"]);
          } else {
            _paq.push(["forgetCookieConsentGiven"]);
          }
          console.log(
            "User consent for app " + app.name + ": consent=" + consent
          );
        }
      },
      required: false,
      optOut: false,
      default: false,
      onlyOnce: true,
    },
  ],
};
